import type { ClientAdvisorSummaryAdmin } from '@agio/core/domain';

/**
 * What "איפוס" has to do to bring the draft back to what is published.
 *
 *  server — the STORED draft differs from what is published: the server resets it
 *           (and the editor follows the answer).
 *  local  — only typing that was never saved differs: throw it away on screen.
 *           Nothing is stored to reset, so asking the server would only fail
 *           (a first draft that was never saved has no row there at all).
 *  nothing — already the same.
 */
export type ResetPlan = 'server' | 'local' | 'nothing';

export function resetPlan(
  summary: Pick<ClientAdvisorSummaryAdmin, 'hasUnpublishedEdits'>,
  unsavedLocalEdits: boolean,
): ResetPlan {
  if (summary.hasUnpublishedEdits) return 'server';
  return unsavedLocalEdits ? 'local' : 'nothing';
}
